import request from './request'
import type { LoginParams, LoginResult } from '../types/api'

export const authApi = {
  login: (params: LoginParams) => 
    request.post<LoginResult>('/auth/login', params),
  
  logout: () => 
    request.post('/auth/logout'),
  
  verify: () => 
    request.post('/auth/verify'),
}
